export default __webpack_public_path__ + "static/media/NP.71de2397.svg";